import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  connect(): void {
    // 3초 후 자동으로 사라지기
    setTimeout(() => {
      this.element.classList.add("opacity-0", "transition-opacity", "duration-500")
      setTimeout(() => {
        this.element.remove()
      }, 500)
    }, 3000)
  }
}
